<ion-item mode="md" lines="none" color="transparent" class="ion-text-center">
  <ion-label mode="md" [color]="textColor" class="label-password-format">
    <ion-text mode="md" class="icon-text">
      <ion-icon
        [color]="isPasswordContain.color"
        [name]="isPasswordContain.name"
        mode="md"
        class="ellipse-sharp"
      ></ion-icon>
      {{ "Labels.between-characters-8-12" | translate }}
    </ion-text>

    <ion-text mode="md" class="icon-text">
      <ion-icon
        [color]="capitalLetter.color"
        [name]="capitalLetter.name"
        class="ellipse-sharp"
      ></ion-icon>
      {{ "Labels.capital-letter" | translate }}
    </ion-text>

    <ion-text mode="md" class="icon-text">
      <ion-icon
        [color]="leastNumber.color"
        [name]="leastNumber.name"
        class="ellipse-sharp"
      ></ion-icon>
      {{ "Labels.least-number" | translate }}
    </ion-text>
  </ion-label>
</ion-item>
